var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c(
        "v-layout",
        { staticClass: "progress-container", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", md10: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      slot: "activator",
                      label: "Task",
                      placeholder: "Enter Task Description",
                      maxlength: 300,
                      counter: "",
                      required: "",
                      "error-messages": _vm.taskErrors
                    },
                    on: {
                      blur: function($event) {
                        return _vm.handleTextTrimmingRequired(
                          "task",
                          _vm.record
                        )
                      }
                    },
                    slot: "activator",
                    model: {
                      value: _vm.record.task,
                      callback: function($$v) {
                        _vm.$set(_vm.record, "task", $$v)
                      },
                      expression: "record.task"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enter Task Description")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md1: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "justify-end": "" } },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            "padding-top": "20px",
                            "padding-bottom": "10px"
                          },
                          attrs: { slot: "activator", id: "deleteIcon" },
                          on: {
                            click: function($event) {
                              return _vm.emitRemoveRecordClicked(_vm.index)
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n            mdi-delete\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Delete Assessment of Performance/Progress")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "10px"
              },
              attrs: { xs12: "", sm6: "", md4: "" }
            },
            [
              _c("h4", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("Measurable Data")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.measurableDialog = true
                        }
                      }
                    },
                    [_vm._v("Open")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "600px" },
                      model: {
                        value: _vm.measurableDialog,
                        callback: function($$v) {
                          _vm.measurableDialog = $$v
                        },
                        expression: "measurableDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("h2", { staticClass: "title-text" }, [
                                _vm._v("Measurable Data")
                              ]),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Completed task\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.measurable[0]
                                                      .value1,
                                                  expression:
                                                    "record.measurable[0].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: {
                                                type: "number",
                                                min: "0"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.record.measurable[0]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.measurable[0],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      out of\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.measurable[0]
                                                      .value2,
                                                  expression:
                                                    "record.measurable[0].value2"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: {
                                                type: "number",
                                                min: "0"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.record.measurable[0]
                                                    .value2
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.measurable[0],
                                                    "value2",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" times")
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.measurable1Checked,
                                  callback: function($$v) {
                                    _vm.measurable1Checked = $$v
                                  },
                                  expression: "measurable1Checked"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Completed task in\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.measurable[1]
                                                      .value1,
                                                  expression:
                                                    "record.measurable[1].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.measurable[1]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.measurable[1],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      minutes\n                    "
                                            )
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.measurable2Checked,
                                  callback: function($$v) {
                                    _vm.measurable2Checked = $$v
                                  },
                                  expression: "measurable2Checked"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Completed task with\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.measurable[2]
                                                      .value1,
                                                  expression:
                                                    "record.measurable[2].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.measurable[2]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.measurable[2],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      % accuracy\n                    "
                                            )
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.measurable3Checked,
                                  callback: function($$v) {
                                    _vm.measurable3Checked = $$v
                                  },
                                  expression: "measurable3Checked"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", block: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.measurableDialog = false
                                    }
                                  }
                                },
                                [_vm._v("Close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.isMobile || _vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs8: "", md4: "" }
                },
                [
                  _vm.record.measurable[0].value1 &&
                  _vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value1) +
                                " out of " +
                                _vm._s(_vm.record.measurable[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[0].value1 &&
                  !_vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value1) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.record.measurable[0].value1 &&
                  _vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[1].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task in " +
                                _vm._s(_vm.record.measurable[1].value1) +
                                " minutes\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable2Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[2].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task with " +
                                _vm._s(_vm.record.measurable[2].value1) +
                                "% accuracy\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable3Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "10px"
              },
              attrs: { xs12: "", sm6: "", md4: "" }
            },
            [
              _c("h4", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("Level of Assistance")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.assistanceDialog = true
                        }
                      }
                    },
                    [_vm._v("Open")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "600px" },
                      model: {
                        value: _vm.assistanceDialog,
                        callback: function($$v) {
                          _vm.assistanceDialog = $$v
                        },
                        expression: "assistanceDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("h2", { staticClass: "title-text" }, [
                                _vm._v("Level of Assistance")
                              ]),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Required assistance\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.assistance[0]
                                                      .value1,
                                                  expression:
                                                    "record.assistance[0].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.assistance[0]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.assistance[0],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      out of\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.assistance[0]
                                                      .value2,
                                                  expression:
                                                    "record.assistance[0].value2"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.assistance[0]
                                                    .value2
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.assistance[0],
                                                    "value2",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" times")
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.assist1Checked,
                                  callback: function($$v) {
                                    _vm.assist1Checked = $$v
                                  },
                                  expression: "assist1Checked"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Required assistance for\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.assistance[1]
                                                      .value1,
                                                  expression:
                                                    "record.assistance[1].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.assistance[1]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.assistance[1],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      minutes\n                    "
                                            )
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.assist2Checked,
                                  callback: function($$v) {
                                    _vm.assist2Checked = $$v
                                  },
                                  expression: "assist2Checked"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              "Required assistance\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.record.assistance[2]
                                                      .value1,
                                                  expression:
                                                    "record.assistance[2].value1"
                                                }
                                              ],
                                              staticClass: "small-input",
                                              attrs: { type: "number" },
                                              domProps: {
                                                value:
                                                  _vm.record.assistance[2]
                                                    .value1
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.record.assistance[2],
                                                    "value1",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      % of the time\n                    "
                                            )
                                          ])
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.assist3Checked,
                                  callback: function($$v) {
                                    _vm.assist3Checked = $$v
                                  },
                                  expression: "assist3Checked"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c("div", [_c("h4", [_vm._v("None")])])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.assist4Checked,
                                  callback: function($$v) {
                                    _vm.assist4Checked = $$v
                                  },
                                  expression: "assist4Checked"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", block: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.assistanceDialog = false
                                    }
                                  }
                                },
                                [_vm._v("Close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.isMobile || _vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs8: "", md4: "" }
                },
                [
                  _vm.record.assistance[0].value1 &&
                  _vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value1) +
                                " out of " +
                                _vm._s(_vm.record.assistance[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[0].value1 &&
                  !_vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value1) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.record.assistance[0].value1 &&
                  _vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[1].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance for " +
                                _vm._s(_vm.record.assistance[1].value1) +
                                " minutes\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance2Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[2].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance for " +
                                _vm._s(_vm.record.assistance[2].value1) +
                                "% of the time\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance3Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.assist4Checked
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v("\n          None\n        ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance4Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "10px"
              },
              attrs: { xs12: "", sm6: "", md4: "" }
            },
            [
              _c("h4", [_vm._v("Type of Assistance")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.typeDialog = true
                        }
                      }
                    },
                    [_vm._v("Open")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "600px" },
                      model: {
                        value: _vm.typeDialog,
                        callback: function($$v) {
                          _vm.typeDialog = $$v
                        },
                        expression: "typeDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("h2", { staticClass: "title-text" }, [
                                _vm._v("Type of Assistance")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    _vm._l(_vm.sessionAssistTypes, function(
                                      item,
                                      index
                                    ) {
                                      return _c("v-checkbox", {
                                        key: index,
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function() {
                                                return [
                                                  _c("h4", [
                                                    _vm._v(_vm._s(item.name))
                                                  ]),
                                                  _vm._v(" "),
                                                  item.name === "Other"
                                                    ? _c("v-text-field", {
                                                        staticStyle: {
                                                          "padding-left":
                                                            "10px",
                                                          "padding-top": "15px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "Enter other value"
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleOtherCheckboxChange(
                                                              index
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.otherTypeValue,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.otherTypeValue = $$v
                                                          },
                                                          expression:
                                                            "otherTypeValue"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.checkedAssistTypes[index],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.checkedAssistTypes,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "checkedAssistTypes[index]"
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", block: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.typeDialog = false
                                    }
                                  }
                                },
                                [_vm._v("Close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.isMobile || _vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs8: "", md4: "" }
                },
                _vm._l(_vm.checkedTypeAssistTypes, function(item, index) {
                  return _c("div", { key: index }, [
                    item.checked
                      ? _c(
                          "div",
                          { staticClass: "text-with-icon" },
                          [
                            item.code !== "OTHER"
                              ? _c("h5", { staticClass: "text" }, [
                                  _vm._v(_vm._s(item.assistType))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.code === "OTHER"
                              ? _c("h5", { staticClass: "text" }, [
                                  _vm._v("Other: " + _vm._s(item.assistType))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                staticClass: "icon",
                                attrs: { "x-small": "", id: "clearIcon" },
                                on: {
                                  click: function($event) {
                                    return _vm.clearTypeValue(item.code)
                                  }
                                }
                              },
                              [_vm._v("\n          mdi-close\n        ")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile && !_vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs4: "", md4: "" }
                },
                [
                  _vm.record.measurable[0].value1 &&
                  _vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value1) +
                                " out of " +
                                _vm._s(_vm.record.measurable[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[0].value1 &&
                  !_vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value1) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.record.measurable[0].value1 &&
                  _vm.record.measurable[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task " +
                                _vm._s(_vm.record.measurable[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[1].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task in " +
                                _vm._s(_vm.record.measurable[1].value1) +
                                " minutes\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable2Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.measurable[2].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Completed task with " +
                                _vm._s(_vm.record.measurable[2].value1) +
                                "% accuracy\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearMeasurable3Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile && !_vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs4: "", md4: "" }
                },
                [
                  _vm.record.assistance[0].value1 &&
                  _vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value1) +
                                " out of " +
                                _vm._s(_vm.record.assistance[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[0].value1 &&
                  !_vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value1) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.record.assistance[0].value1 &&
                  _vm.record.assistance[0].value2
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance " +
                                _vm._s(_vm.record.assistance[0].value2) +
                                " times\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance1Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[1].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance for " +
                                _vm._s(_vm.record.assistance[1].value1) +
                                " minutes\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance2Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.assistance[2].value1
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v(
                              "\n          Required assistance for " +
                                _vm._s(_vm.record.assistance[2].value1) +
                                "% of the time\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance3Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.assist4Checked
                    ? _c(
                        "div",
                        { staticClass: "text-with-icon" },
                        [
                          _c("h5", { staticClass: "text" }, [
                            _vm._v("\n          None\n        ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon",
                              attrs: { "x-small": "", id: "clearIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.clearAssistance4Values()
                                }
                              }
                            },
                            [_vm._v("\n          mdi-close\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile && !_vm.isTablet
            ? _c(
                "v-flex",
                {
                  staticClass: "display-values",
                  staticStyle: { display: "flex", "align-items": "right" },
                  attrs: { xs4: "", md4: "" }
                },
                _vm._l(_vm.checkedTypeAssistTypes, function(item, index) {
                  return _c("div", { key: index }, [
                    item.checked
                      ? _c(
                          "div",
                          { staticClass: "text-with-icon" },
                          [
                            item.code !== "OTHER"
                              ? _c("h5", { staticClass: "text" }, [
                                  _vm._v(_vm._s(item.assistType))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.code === "OTHER"
                              ? _c("h5", { staticClass: "text" }, [
                                  _vm._v("Other: " + _vm._s(item.assistType))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                staticClass: "icon",
                                attrs: { "x-small": "", id: "clearIcon" },
                                on: {
                                  click: function($event) {
                                    return _vm.clearTypeValue(item.code)
                                  }
                                }
                              },
                              [_vm._v("\n          mdi-close\n        ")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68af815d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68af815d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/progress-repeatable.vue
// module id = null
// module chunks = 